import {Component, Input} from '@angular/core';

export interface MenuItem {
	label: string;
	action: () => void;
}


@Component({
  selector: 'cass-button-dropdown',
  templateUrl: './cass-button-dropdown.component.html',
  styleUrls: ['./cass-button-dropdown.component.css']
})
export class CassButtonDropdownComponent {
	@Input() buttonLabel = 'Options';
	@Input() menuItems: MenuItem[] = [];
	@Input() hideIcon: boolean = false;
}
